<template>
  <v-dialog v-model="loadingDialogShow" persistent style="width: 520px; height: 300px" no-click-animation>
    <div class="loading-card">
      <img src="../../../../assets/file_manage/cg_icon.png"
           style="position: absolute;right: 21px;top: 9px;width: 94px;height: 35px">
      <p class="loading-text">{{ text }}</p>
      <img src="../../../../assets/file_manage/loading.gif"
           style="height: 150px;width: 150px;position: absolute;left: 75px;top: 70px">
      <p @click="cancel"
         style="position:absolute;bottom: 23px;right: 33px;font-size: 16px;color: rgb(128,128,128);cursor: pointer">
        取消</p>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'loadingDialog',
  props: ['loadingDialogShow', 'text'],
  methods: {
    cancel() {
      this.$emit('closeLoadingDialog')
    }
  }
}
</script>

<style scoped>
.loading-card {
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  width: 520px;
  height: 300px;
  border-radius: 10px;
  background: linear-gradient(225.41deg, rgba(213, 239, 252, 1) 0%, rgba(255, 255, 255, 1) 53.24%, rgba(213, 239, 252, 1) 100%);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
}
.loading-text {
  font-size: 20px;
  font-weight: 400;
  background-image: linear-gradient(360deg, rgba(79, 172, 254, 1) 0%, rgba(0, 242, 254, 1) 100%);
  -webkit-background-clip: text;
  color: transparent;
  text-align: left;
  vertical-align: top;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
}
</style>